var toString = Function.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty
var regexpCharacters = /[\\^$.*+?()[\]{}|]/g
var regexpIsNativeFn = toString.call(hasOwnProperty)
  .replace(regexpCharacters, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?')
var regexpIsNative = RegExp('^' + regexpIsNativeFn + '$')
function toSource (func) {
  if (!func) return ''
  try {
    return toString.call(func)
  } catch (e) {}
  try {
    return (func + '')
  } catch (e) {}
}
var assign = Object.assign
var forEach = Array.prototype.forEach
var every = Array.prototype.every
var filter = Array.prototype.filter
var find = Array.prototype.find
var indexOf = Array.prototype.indexOf
var isArray = Array.isArray
var keys = Object.keys
var map = Array.prototype.map
var reduce = Array.prototype.reduce
var slice = Array.prototype.slice
var some = Array.prototype.some
var values = Object.values
function isNative (method) {
  return method && typeof method === 'function' && regexpIsNative.test(toSource(method))
}
var _ = {
  assign: isNative(assign)
    ? assign
    : function assign (target) {
      var l = arguments.length
      for (var i = 1; i < l; i++) {
        var source = arguments[i]
        for (var j in source) if (source.hasOwnProperty(j)) target[j] = source[j]
      }
      return target
    },
  bind: function bind (method, context) {
    var args = _.slice(arguments, 2)
    return function boundFunction () {
      return method.apply(context, args.concat(_.slice(arguments)))
    }
  },
  debounce: function debounce (func, wait, immediate) {
    var timeout
    return function () {
      var context = this
      var args = arguments
      var later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }
      var callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }
  },
  each: isNative(forEach)
    ? function nativeEach (array, callback, context) {
      return forEach.call(array, callback, context)
    }
    : function each (array, callback, context) {
      var l = array.length
      for (var i = 0; i < l; i++) callback.call(context, array[i], i, array)
    },
  every: isNative(every)
    ? function nativeEvery (coll, pred, context) {
      return every.call(coll, pred, context)
    }
    : function every (coll, pred, context) {
      if (!coll || !pred) {
        throw new TypeError()
      }
      for (var i = 0; i < coll.length; i++) {
        if (!pred.call(context, coll[i], i, coll)) {
          return false
        }
      }
      return true
    },
  filter: isNative(filter)
    ? function nativeFilter (array, callback, context) {
      return filter.call(array, callback, context)
    }
    : function filter (array, callback, context) {
      var l = array.length
      var output = []
      for (var i = 0; i < l; i++) {
        if (callback.call(context, array[i], i, array)) output.push(array[i])
      }
      return output
    },
  find: isNative(find)
    ? function nativeFind (array, callback, context) {
      return find.call(array, callback, context)
    }
    : function find (array, callback, context) {
      var l = array.length
      for (var i = 0; i < l; i++) {
        if (callback.call(context, array[i], i, array)) return array[i]
      }
    },
  get: function get (object, path) {
    return _.reduce(path.split('.'), function (memo, next) {
      return (typeof memo !== 'undefined' && memo !== null) ? memo[next] : undefined
    }, object)
  },
  identity: function identity (value) {
    return value
  },
  indexOf: isNative(indexOf)
    ? function nativeIndexOf (array, item) {
      return indexOf.call(array, item)
    }
    : function indexOf (array, item) {
      var l = array.length
      for (var i = 0; i < l; i++) {
        if (array[i] === item) return i
      }
      return -1
    },
  invoke: function invoke (array, methodName) {
    var args = _.slice(arguments, 2)
    return _.map(array, function invokeMapper (value) {
      return value[methodName].apply(value, args)
    })
  },
  isArray: isNative(isArray)
    ? function nativeArray (coll) {
      return isArray(coll)
    }
    : function isArray (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]'
    },
  isMatch: function isMatch (obj, spec) {
    for (var i in spec) {
      if (spec.hasOwnProperty(i) && obj[i] !== spec[i]) return false
    }
    return true
  },
  isObject: function isObject (obj) {
    var type = typeof obj
    return type === 'function' || type === 'object' && !!obj
  },
  keys: isNative(keys)
    ? keys
    : function keys (object) {
      var keys = []
      for (var key in object) {
        if (object.hasOwnProperty(key)) keys.push(key)
      }
      return keys
    },
  map: isNative(map)
    ? function nativeMap (array, callback, context) {
      return map.call(array, callback, context)
    }
    : function map (array, callback, context) {
      var l = array.length
      var output = new Array(l)
      for (var i = 0; i < l; i++) {
        output[i] = callback.call(context, array[i], i, array)
      }
      return output
    },
  matches: function matches (spec) {
    return function (obj) {
      return _.isMatch(obj, spec)
    }
  },
  not: function not (value) {
    return !value
  },
  objectEach: function (object, callback, context) {
    return _.each(_.keys(object), function (key) {
      return callback.call(context, object[key], key, object)
    }, context)
  },
  objectMap: function objectMap (object, callback, context) {
    var result = {}
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        result[key] = callback.call(context, object[key], key, object)
      }
    }
    return result
  },
  objectReduce: function objectReduce (object, callback, initialValue) {
    var output = initialValue
    for (var i in object) {
      if (object.hasOwnProperty(i)) output = callback(output, object[i], i, object)
    }
    return output
  },
  pick: function pick (object, toPick) {
    var out = {}
    _.each(toPick, function (key) {
      if (typeof object[key] !== 'undefined') out[key] = object[key]
    })
    return out
  },
  pluck: function pluck (array, key) {
    var l = array.length
    var out = []
    for (var i = 0; i < l; i++) if (array[i]) out[i] = array[i][key]
    return out
  },
  reduce: isNative(reduce)
    ? function nativeReduce (array, callback, initialValue) {
      return reduce.call(array, callback, initialValue)
    }
    : function reduce (array, callback, initialValue) {
      var output = initialValue
      var l = array.length
      for (var i = 0; i < l; i++) output = callback(output, array[i], i, array)
      return output
    },
  set: function set (object, path, val) {
    if (!object) return object
    if (typeof object !== 'object' && typeof object !== 'function') return object
    var parts = path.split('.')
    var context = object
    var nextKey
    do {
      nextKey = parts.shift()
      if (typeof context[nextKey] !== 'object') context[nextKey] = {}
      if (parts.length) {
        context = context[nextKey]
      } else {
        context[nextKey] = val
      }
    } while (parts.length)
    return object
  },
  slice: isNative(slice)
    ? function nativeSlice (array, begin, end) {
      begin = begin || 0
      end = typeof end === 'number' ? end : array.length
      return slice.call(array, begin, end)
    }
    : function slice (array, start, end) {
      start = start || 0
      end = typeof end === 'number' ? end : array.length
      var length = array == null ? 0 : array.length
      if (!length) {
        return []
      }
      if (start < 0) {
        start = -start > length ? 0 : (length + start)
      }
      end = end > length ? length : end
      if (end < 0) {
        end += length
      }
      length = start > end ? 0 : ((end - start) >>> 0)
      start >>>= 0
      var index = -1
      var result = new Array(length)
      while (++index < length) {
        result[index] = array[index + start]
      }
      return result
    },
  some: isNative(some)
    ? function nativeSome (coll, pred, context) {
      return some.call(coll, pred, context)
    }
    : function some (coll, pred, context) {
      if (!coll || !pred) {
        throw new TypeError()
      }
      for (var i = 0; i < coll.length; i++) {
        if (pred.call(context, coll[i], i, coll)) {
          return true
        }
      }
      return false
    },
  unique: function unique (array) {
    return _.reduce(array, function (memo, curr) {
      if (_.indexOf(memo, curr) === -1) {
        memo.push(curr)
      }
      return memo
    }, [])
  },
  values: isNative(values)
    ? values
    : function values (object) {
      var out = []
      for (var key in object) {
        if (object.hasOwnProperty(key)) out.push(object[key])
      }
      return out
    },
  name: 'slapdash',
  version: '1.3.3'
}
_.objectMap.asArray = function objectMapAsArray (object, callback, context) {
  return _.map(_.keys(object), function (key) {
    return callback.call(context, object[key], key, object)
  }, context)
}
module.exports = _
